import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import './pageSpy';

console.log('env', import.meta.env.VITE_SENTRY_ENV, __APP_VERSION__, __IS_BUILD_IN_CI__);
if (__IS_BUILD_IN_CI__) {
  const release = `${__APP_VERSION__}`;
  try {
    Sentry.init({
      dsn: 'https://c26cbaed6b7f44a8918815cba2256217@sentry.cvtapi.com/569',
      tracesSampleRate: 1.0,
      integrations: [new BrowserTracing()],
      release,
      environment: import.meta.env.VITE_SENTRY_ENV,
    });
  } catch (error) {
    console.error(error);
  }
}